module.exports = __webpack_public_path__ + "img/3_02.69be51fe.jpg";